/**
 * saveOrUpdateAIHistory 的 aiSource 字段（与后端约定）
 * 101 Pollo 102 AllAll 103 火山方舟 104 阿里云百炼 105 Google
 * 106 快手可灵 107 OpenAI 108 上海稀宇海螺 109 美国 RunwayML
 * 110 德国 Black Forest Labs 111 美国 Suno
 */
export var HISTORY_SOURCE_POLLO = 101
export var HISTORY_SOURCE_ALLALL = 102
export var HISTORY_SOURCE_VOLC_ARK = 103
export var HISTORY_SOURCE_BAILIAN = 104
export var HISTORY_SOURCE_GOOGLE = 105
export var HISTORY_SOURCE_KLING = 106
export var HISTORY_SOURCE_OPENAI = 107
export var HISTORY_SOURCE_HAILUO = 108
export var HISTORY_SOURCE_RUNWAY = 109
export var HISTORY_SOURCE_SUNO = 111
